module.exports = __webpack_public_path__ + "img/award-c.5d446b73.png";